import axios from "axios";
import { ENDPOINTS } from "../jsx/services/ENDPOINT";
import { getAllExpense } from "./expenseApi";


const BASE = `${ENDPOINTS.BASE_2}`;

// ================= INGREDIENTS =================
export const getIngredients = () =>
  axios.get(`${BASE}/ingredients`);

export const syncIngredientsFromExpense = (items) =>
  axios.post(`${BASE}/ingredients/sync`, { items });

export const deductIngredientStock = (id, data) =>
  axios.put(`${BASE}/ingredients/${id}/deduct`, data);

export const getIngredientHistory = (id) =>
  axios.get(`${BASE}/ingredients/usage/${id}`);

// ================= EXPENSE → INGREDIENT FLATTEN =================
export const getIngredientsFromExpenses = async () => {
  const res = await getAllExpense();

  const expenses = res?.data?.data || [];

  let items = [];

  expenses.forEach((exp) => {
    if (Array.isArray(exp.items)) {
      exp.items.forEach((it) => {
        items.push({
          id: it.id,
          name: it.name,
          qty: Number(it.qty || 0),
          unit: it.unit,
          rate: Number(it.rate || 0),
        });
      });
    }
  });

  return items;
};